import { Link } from "react-router-dom";
import type { Anime } from "@/types/anime";

interface AnimeCardProps {
  anime: Anime;
  showSummary?: boolean;
}

export default function AnimeCard({ anime, showSummary = true }: AnimeCardProps) {
  return (
    <Link
      to={`/detail/${anime.id}`}
      className="group block bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors"
    >
      <div className="flex gap-3 p-3">
        <div className="relative w-[110px] h-[146px] sm:w-[120px] sm:h-[160px] shrink-0 rounded-md overflow-hidden bg-background-200">
          <img
            src={anime.cover}
            alt={anime.title}
            title={`${anime.title} - 在线观看`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
          />
          <span className="absolute top-1.5 left-1.5 px-1.5 py-0.5 rounded bg-primary-500 text-background-50 text-[10px] font-medium">
            {anime.status}
          </span>
        </div>

        <div className="flex flex-col min-w-0 flex-1">
          <h3 className="font-heading font-bold text-foreground-950 text-sm md:text-base truncate group-hover:text-primary-600 transition-colors">
            {anime.title}
          </h3>
          <div className="flex flex-wrap items-center gap-1.5 mt-1.5">
            <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-[11px]">
              {anime.category}
            </span>
            <span className="px-2 py-0.5 rounded-full bg-background-100 text-foreground-600 text-[11px]">
              {anime.region}
            </span>
            <span className="px-2 py-0.5 rounded-full bg-background-100 text-foreground-600 text-[11px]">
              {anime.year}
            </span>
          </div>

          {showSummary && (
            <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2 hidden sm:block">
              {anime.summary}
            </p>
          )}

          <div className="mt-auto pt-2 flex items-center justify-between gap-2 text-[11px] text-foreground-500">
            <span className="flex items-center gap-1 whitespace-nowrap">
              <i className="ri-time-line text-primary-500"></i>
              {anime.updatedAt}
            </span>
            <span className="flex items-center gap-1 whitespace-nowrap font-medium text-accent-700">
              <i className="ri-star-fill"></i>
              {anime.rating}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}